var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrologyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.3621 42.0693C59.131 42.0819 61.3691 44.3459 61.3691 47.1345C61.3691 49.8802 59.143 52.2676 56.4175 52.3395L52.029 52.3395C48.2541 48.5379 51.0047 42.0693 56.3621 42.0693Z",
    fill: "url(#paint0_linear_3679_5823)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.832 56.5999C41.8447 59.3688 44.127 61.6069 46.938 61.6069C49.7059 61.6069 52.1124 59.3808 52.1849 56.6553L52.1849 53.2687C52.1849 53.2687 51.7344 47.4787 52.9062 45.1831C53.8819 43.2717 56.3605 42.0686 56.3605 42.0686L49.832 42.0686C45.4137 42.0686 41.832 45.6503 41.832 50.0686L41.832 56.5999Z",
    fill: "#59C3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0403 36.5566C19.2713 36.5441 17.0332 34.28 17.0332 31.4915C17.0332 28.7457 19.2593 26.3584 21.9849 26.2865L26.3734 26.2865C30.1483 30.0881 27.3977 36.5566 22.0403 36.5566Z",
    fill: "url(#paint1_linear_3679_5823)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5723 22.2761C36.5598 19.5071 34.3169 17.269 31.5543 17.269C28.8342 17.269 26.4691 19.4952 26.3979 22.2207V26.3587C26.3979 26.3587 26.8406 31.1468 25.689 33.4424C24.7301 35.3538 22.2943 36.5569 22.2943 36.5569H28.5723C32.9905 36.5569 36.5723 32.9751 36.5723 28.5569V22.2761Z",
    fill: "#59C3FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5078 56.6909C36.4954 59.4427 34.2611 61.667 31.5093 61.667C28.7996 61.667 26.4436 59.4546 26.3727 56.7459L26.3727 52.3907C30.1128 48.6506 36.5078 51.4015 36.5078 56.6909Z",
    fill: "url(#paint2_linear_3679_5823)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0403 42.0684C19.2713 42.081 17.0332 44.3633 17.0332 47.1743C17.0332 49.9422 19.2593 52.3488 21.9849 52.4213L26.3734 52.4213C26.3734 52.4213 31.1615 51.9707 33.4571 53.1426C35.3685 54.1183 36.5715 56.5968 36.5715 56.5968L36.5715 50.0684C36.5715 45.6501 32.9898 42.0684 28.5715 42.0684L22.0403 42.0684Z",
    fill: "#257CFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9414 22.1724C41.9538 19.4206 44.1881 17.1963 46.94 17.1963C49.6496 17.1963 52.0056 19.4086 52.0766 22.1174L52.0766 26.4726C48.3364 30.2127 41.9414 27.4617 41.9414 22.1724Z",
    fill: "url(#paint3_linear_3679_5823)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.409 36.7949C59.1779 36.7823 61.416 34.5 61.416 31.689C61.416 28.9211 59.1899 26.5145 56.4643 26.442L52.0758 26.442C52.0758 26.442 47.2878 26.8926 44.9921 25.7207C43.0808 24.745 41.8777 22.2664 41.8777 22.2664L41.8777 28.7949C41.8777 33.2132 45.4594 36.7949 49.8777 36.7949L56.409 36.7949Z",
    fill: "#257CFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3679_5823",
    x1: 62.4433,
    y1: 45.5864,
    x2: 43.0068,
    y2: 52.2287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59C3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3679_5823",
    x1: 15.9591,
    y1: 33.0396,
    x2: 35.3956,
    y2: 26.3973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59C3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3679_5823",
    x1: 33.037,
    y1: 62.7341,
    x2: 26.4028,
    y2: 43.4511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#257CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFE2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3679_5823",
    x1: 45.4122,
    y1: 16.1291,
    x2: 52.0464,
    y2: 35.4121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#257CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFE2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrologyIcon);
export default __webpack_public_path__ + "static/media/urology-icon.00961435300ed2448316ac7cbd0bdd88.svg";
export { ForwardRef as ReactComponent };